import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/management/roadmap-stage";
export const managementPlatformRoadmap = createCrudVuexModule({
  namespaced: true,
  path,
  state: {
    editedTask: undefined,
    tasks: [],
    editedStages: [],
    //
    descriptionSystemAndRoadmapTutorial: undefined,
    descriptionOrganizationDetail: undefined,
    descriptionOrganizationHierarchy: undefined,
    descriptionThirdParty: undefined,
    descriptionPlatformPolicy: undefined,
    //
    isSystemAndRoadmapTutorialLoading: false,
    isOrganizationDetailLoading: false,
    isOrganizationHierarchyLoading: false,
    isThirdPartyLoading: false,
    isPlatformPolicyLoading: false,
  },
  getters: {
    editedTask: (state) => state.editedTask,
    tasks: (state) => state.tasks,
    editedStages: (state) => state.editedStages,
    //
    descriptionSystemAndRoadmapTutorial: (state) => state.descriptionSystemAndRoadmapTutorial,
    descriptionOrganizationDetail: (state) => state.descriptionOrganizationDetail,
    descriptionOrganizationHierarchy: (state) => state.descriptionOrganizationHierarchy,
    descriptionThirdParty: (state) => state.descriptionThirdParty,
    descriptionPlatformPolicy: (state) => state.descriptionPlatformPolicy,
    //
    isSystemAndRoadmapTutorialLoading: (state) => state.isSystemAndRoadmapTutorialLoading,
    isOrganizationDetailLoading: (state) => state.isOrganizationDetailLoading,
    isOrganizationHierarchyLoading: (state) => state.isOrganizationHierarchyLoading,
    isThirdPartyLoading: (state) => state.isThirdPartyLoading,
    isPlatformPolicyLoading: (state) => state.isPlatformPolicyLoading,
  },
  mutations: {
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
      state.editedStages = [];

      state.descriptionSystemAndRoadmapTutorial = undefined;
      state.descriptionOrganizationDetail = undefined;
      state.descriptionOrganizationHierarchy = undefined;
      state.descriptionThirdParty = undefined;
      state.descriptionPlatformPolicy = undefined;

      state.isSystemAndRoadmapTutorialLoading = false;
      state.isOrganizationDetailLoading = false;
      state.isOrganizationHierarchyLoading = false;
      state.isThirdPartyLoading = false;
      state.isPlatformPolicyLoading = false;

      state.isUpdating = false;
      state.isLoading = false;
    },

    clearEditedStages: (state, value) => (state.editedStages = []),

    isSystemAndRoadmapTutorialLoading: (state, value) => (state.isSystemAndRoadmapTutorialLoading = value),
    isOrganizationDetailLoading: (state, value) => (state.isOrganizationDetailLoading = value),
    isOrganizationHierarchyLoading: (state, value) => (state.isOrganizationHierarchyLoading = value),
    isThirdPartyLoading: (state, value) => (state.isThirdPartyLoading = value),
    isPlatformPolicyLoading: (state, value) => (state.isPlatformPolicyLoading = value),

    descriptionSystemAndRoadmapTutorial: (state, value) => {
      state.descriptionSystemAndRoadmapTutorial = value;
      if (!state.editedStages.includes("SYSTEM_AND_ROADMAP_TUTORIAL")) {
        state.editedStages.push("SYSTEM_AND_ROADMAP_TUTORIAL");
      }
    },
    descriptionOrganizationDetail: (state, value) => {
      state.descriptionOrganizationDetail = value;
      if (!state.editedStages.includes("ORGANIZATION_DETAIL")) {
        state.editedStages.push("ORGANIZATION_DETAIL");
      }
    },
    descriptionOrganizationHierarchy: (state, value) => {
      state.descriptionOrganizationHierarchy = value;

      if (!state.editedStages.includes("ORGANIZATION_HIERARCHY")) {
        state.editedStages.push("ORGANIZATION_HIERARCHY");
      }
    },
    descriptionThirdParty: (state, value) => {
      state.descriptionThirdParty = value;

      if (!state.editedStages.includes("THIRD_PARTY")) {
        state.editedStages.push("THIRD_PARTY");
      }
    },
    descriptionPlatformPolicy: (state, value) => {
      state.descriptionPlatformPolicy = value;

      if (!state.editedStages.includes("PLATFORM_POLICY")) {
        state.editedStages.push("PLATFORM_POLICY");
      }
    },

    editedTask: (state, value) => (state.editedTask = value),

    addTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.filter((t) => t._id != task._id);
    },
  },
  actions: {
    async save({ getters, commit, dispatch }) {
      try {
        commit("isUpdating", true);

        const response = await Promise.all(
          getters.editedStages.map(async (stage) => {
            let payload = {
              tasks: getters.tasks.filter((t) => t.stage == stage),
              roadmapDefinition: "PLATFORM_ROADMAP",
              definition: stage,
              description: null,
              next: null,
            };

            if (stage == "SYSTEM_AND_ROADMAP_TUTORIAL") {
              payload.description = getters.descriptionSystemAndRoadmapTutorial;
              payload.next = ["ORGANIZATION_DETAIL"];
              payload.first = true;
            } else if (stage == "ORGANIZATION_DETAIL") {
              payload.description = getters.descriptionOrganizationDetail;
              payload.next = ["ORGANIZATION_HIERARCHY", "THIRD_PARTY"];
            } else if (stage == "ORGANIZATION_HIERARCHY") {
              payload.description = getters.descriptionOrganizationHierarchy;
            } else if (stage == "THIRD_PARTY") {
              payload.description = getters.descriptionThirdParty;
              payload.next = ["PLATFORM_POLICY"];
            } else if (stage == "PLATFORM_POLICY") {
              payload.description = getters.descriptionPlatformPolicy;
              payload.next = ["GDPR_INVENTORY_UPDATE", "KVKK_INVENTORY_UPDATE"]; //GDPR Roadmap
            }

            try {
              commit("isUpdating", true);
              payload = await dispatch("preparePayload", {
                editedEntity: {},
                form: payload,
              });

              const response = await rest.put(`${path}`, { item: payload });
              return response;
            } catch (e) {
              console.error(e);
            }
          })
        );

        return response;
      } finally {
        commit("reset");
      }
    },

    async loadStages({ getters, rootGetters, commit, dispatch }) {
      try {
        commit("reset");

        const language = rootGetters["user/account"].language ?? "tr";
        const stages = ["SYSTEM_AND_ROADMAP_TUTORIAL", "ORGANIZATION_DETAIL", "ORGANIZATION_HIERARCHY", "THIRD_PARTY", "PLATFORM_POLICY"];
        const response = await Promise.all(
          stages.map(async (stage) => {
            try {
              if (stage == "SYSTEM_AND_ROADMAP_TUTORIAL") {
                commit("isSystemAndRoadmapTutorialLoading", true);
              } else if (stage == "ORGANIZATION_DETAIL") {
                commit("isOrganizationDetailLoading", true);
              } else if (stage == "ORGANIZATION_HIERARCHY") {
                commit("isOrganizationHierarchyLoading", true);
              } else if (stage == "THIRD_PARTY") {
                commit("isThirdPartyLoading", true);
              } else if (stage == "PLATFORM_POLICY") {
                commit("isPlatformPolicyLoading", true);
              }

              const response = await rest.post(`${path}`, { roadmapDefinition: "PLATFORM_ROADMAP", definition: stage });
              if (response?.data && typeof response.data === "object") {
                if (response.data.description) {
                  const description = response.data.description[language];

                  if (stage == "SYSTEM_AND_ROADMAP_TUTORIAL") {
                    commit("descriptionSystemAndRoadmapTutorial", description);
                  } else if (stage == "ORGANIZATION_DETAIL") {
                    commit("descriptionOrganizationDetail", description);
                  } else if (stage == "ORGANIZATION_HIERARCHY") {
                    commit("descriptionOrganizationHierarchy", description);
                  } else if (stage == "THIRD_PARTY") {
                    commit("descriptionThirdParty", description);
                  } else if (stage == "PLATFORM_POLICY") {
                    commit("descriptionPlatformPolicy", description);
                  }
                }

                response.data.tasks.forEach((task) => {
                  task.stage = stage;
                  task.description = task.description;
                  commit("addTaskItemsToStage", { task });
                });
              }
              return response?.data;
            } catch (e) {
              console.error(e);
            } finally {
              if (stage == "SYSTEM_AND_ROADMAP_TUTORIAL") {
                commit("isSystemAndRoadmapTutorialLoading", false);
              } else if (stage == "ORGANIZATION_DETAIL") {
                commit("isOrganizationDetailLoading", false);
              } else if (stage == "ORGANIZATION_HIERARCHY") {
                commit("isOrganizationHierarchyLoading", false);
              } else if (stage == "THIRD_PARTY") {
                commit("isThirdPartyLoading", false);
              } else if (stage == "PLATFORM_POLICY") {
                commit("isPlatformPolicyLoading", false);
              }
            }
          })
        );

        return response;
      } catch (e) {
        console.error(e);
      } finally {
        commit("clearEditedStages");
      }
    },
  },
});
